import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { Tags, TagsUpsert } from '../../_objects/tags';
import { HttpService } from '../http.service';

@Injectable({
  providedIn: 'root'
})
export class TagsOnlineService extends HttpService {
  constructor(
    private http: HttpClient,
    private cookieService: CookieService,
    private router: Router,
  ) {
    super();
    super.setCookieService(cookieService);
    super.setHttpClient(http);
    super.setRouter(router);
  }
  // 01 /api/v1/tags
  getTags(): Observable<Tags> {
    const endpoint = super.getEndpoint('tags');

      return this.http.get<Tags>(endpoint,
        {  withCredentials: super.getWithCredentialsOption() }).pipe(map(response => response as Tags));
  }

  // 02 /api/tenant/v1/{tenantId}/tags
  upsertTags(tagsUpsert: TagsUpsert): Observable<Tags> {
    const endpoint = super.getEndpoint('tags');

      return this.http.put<Tags>(
        endpoint,
        tagsUpsert,
        {  withCredentials: super.getWithCredentialsOption() }
      ).pipe(map(response => response as Tags));
  }
}
